import { jsx, jsxs } from "react/jsx-runtime";
import { Popover } from "@base-ui/react/popover";
import { memo } from "react";
import { TravelerSelectionContent } from "../TravelerSelectionContent/TravelerSelectionContent.js";
function TravelerSelectionDesktop({ ageSelectEnabled, handleClose, disclaimer, isHotel, lapInfantLabel, maxAdults, maxChildren, maxRooms, fireMaxRoomsOnClick, maxRoomsMessage, maxRoomsUrl, roomsEnabled, shouldCountLapInfant, state, subLabelMap, isOpen, renderInput, handleOpen, collisionAvoidance }) {
    return /*#__PURE__*/ jsx("div", {
        className: "flex w-full flex-row",
        "data-testid": "traveler-selection-desktop",
        children: /*#__PURE__*/ jsxs(Popover.Root, {
            open: isOpen,
            onOpenChange: handleOpen,
            children: [
                /*#__PURE__*/ jsx(Popover.Trigger, {
                    render: renderInput
                }),
                /*#__PURE__*/ jsx(Popover.Portal, {
                    "data-testid": "traveler-selection-desktop-portal",
                    children: /*#__PURE__*/ jsx(Popover.Positioner, {
                        sideOffset: 12,
                        align: "start",
                        className: "w-[--available-width]",
                        collisionAvoidance: collisionAvoidance,
                        children: /*#__PURE__*/ jsxs(Popover.Popup, {
                            className: "w-[var(--anchor-width)] min-w-[340px] origin-[var(--transform-origin)] rounded-lg bg-primary-1 px-4 pt-2 pb-4 shadow-overlay-md transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[ending-style]:opacity-0 data-[starting-style]:scale-90 data-[starting-style]:opacity-0",
                            children: [
                                /*#__PURE__*/ jsx(Popover.Arrow, {
                                    className: ""
                                }),
                                /*#__PURE__*/ jsx(Popover.Title, {
                                    className: "sr-only",
                                    children: "Traveler Selection"
                                }),
                                /*#__PURE__*/ jsx(TravelerSelectionContent, {
                                    displayDoneButton: true,
                                    handleClose: handleClose,
                                    ageSelectEnabled: ageSelectEnabled,
                                    disclaimer: disclaimer,
                                    isHotel: isHotel,
                                    lapInfantLabel: lapInfantLabel,
                                    maxAdults: maxAdults,
                                    maxChildren: maxChildren,
                                    maxRooms: maxRooms,
                                    maxRoomsMessage: maxRoomsMessage,
                                    maxRoomsUrl: maxRoomsUrl,
                                    roomsEnabled: roomsEnabled,
                                    shouldCountLapInfant: shouldCountLapInfant,
                                    state: state,
                                    subLabelMap: subLabelMap,
                                    fireMaxRoomsOnClick: fireMaxRoomsOnClick
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
const TravelerSelection_TravelerSelectionDesktop = /*#__PURE__*/ memo(TravelerSelectionDesktop);
export { TravelerSelectionDesktop, TravelerSelection_TravelerSelectionDesktop as default };
